// Constants
import { DESC } from 'Angular/constants/core.constants';
import { CustomPDFReportDesignation } from 'CustomPDFReportsApp/ts/enums/custom-pdf-report-designation.enum';
// Interfaces
import { DefaultSortDirectionConfig } from 'Angular/utils/sort/interfaces/default-sort-direction-config.interface';

export const COMPLIANCE_REPORT_HISTORY_DEFAULT_SORT_DIRECTIONS: DefaultSortDirectionConfig = { download_date: DESC };

/**
 * Represents valid options for columns to sort by on the compliance report history page.
 */
export enum ComplianceReportHistoryPageSortColumn {
    DOWNLOAD_DATE = 'download_date',
    TITLE = 'title',
    PREPARED_FOR = 'prepared_for',
    DESIGNATION_TYPE = 'designation_type',
    REPORT_TYPE = 'type',
    CUSTOM_FIELD = 'custom_field',
}

export const COMPLIANCE_REPORT_HISTORY_PAGE_CUSTOM_PDF_DESIGNATION_TYPES = [
    CustomPDFReportDesignation.DRAFT,
    CustomPDFReportDesignation.DELIVERABLE,
];

export const COMPLIANCE_REPORT_HISTORY_PAGE_TYPE_LABELS = {
    pdf_report: 'PDF Report',
    comp_table: 'Comp Table',
    fund_chart: 'Fund Chart',
    legacy_tearsheets: 'Tearsheet',
    legacy_y_rating: 'Y-Rating',
    timeseries_table: 'Timeseries Analysis',
    holdings_category: 'Holdings Category',
    holdings_overlap: 'Holdings Overlap',
    expanded_holdings: 'Expanded Holdings',
    hypotheticals: 'Hypotheticals',
    portfolio_optimizer: 'Portfolio Optimizer',
    stress_test: 'Stress Test',
    attribution_table: 'Attribution Table',
    attribution_analysis: 'Attribution Analysis',
    transition_analysis: 'Transition Analysis',
    target_rates: 'Target Rates',
};

export const COMPLIANCE_REPORT_HISTORY_DOWNLOAD_RADIO_BUTTON_OPTIONS = [
    { label: 'Download Original Report', value: 'download', disabled: false },
    { label: 'Regenerate Report with New Data', value: 'regenerate', disabled: false },
];
